module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAyklEQVRYw2O47WLeAMT/Bwg3MAyg5WA86oBRB4w6YNQBQ8cBn3ZuAeMBccDLrqb/MABi09UBj9Jj///9/BnuABAbJEYXB9wNcPn/+8Wz/+gAJAaSo0aU4XXAl6MH/+MCIDlc+l5P64erA7HJcsDbRbP/EwIgNej6ntWVYagDiZHkgCfFmf+JBSC1uNILMekGwwEPogOwGoILgNSC9OBKL4TSDYYDfty59Z9UANJDjD6QGoIOoDUYdcDgd8BodTzqgFEHDIQDBrR7DgBGdZVPSID9BgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./app/assets/file-icons/image.png
// module id = 1616
// module chunks = 0